/**
 * @type {string} - Base category for editorial reports.
 */
export const CAT_ED_REP_BASE = 'catEdRep';

/**
 * @type {string} - Base category for creative reports.
 */
export const CAT_CR_REP_BASE = 'catCrRep';

/**
 * @name REPORT_TYPE
 * @type {{
 *  ED_MOST_VIEWED: string,
 *  ED_OUTSTANDING: string,
 *  ED_LAST_HOUR: string,
 *  ED_LAST_VIDEOS: string,
 *  ED_FAMOUS: string,
 *  ED_PERFORMANCE: string,
 *  ED_ROYAL: string,
 *  ED_SPORTS: string,
 *  ED_FASHION: string,
 *  ED_POLITICS: string,
 *  ED_SOCIETY: string,
 *  ED_ARCHIVE: string,
 *  ED_PREMIUM: string,
 *  ED_CLOSED: string,
 *  ED_VPRIORITY: string,
 *  ED_VEDITADOS: string,
 *  CR_MOST_VIEWED: string,
 *  CR_OUTSTANDING: string,
 *  CR_LAST_HOUR: string,
 *  CR_LAST_VIDEOS: string,
 *  CR_NOURISHMENT: string,
 *  CR_BEAUTY: string,
 *  CR_DECORATION: string,
 *  CR_NATURE: string,
 *  CR_TRAVEL: string,
 *  CR_FASHION: string,
 *  CR_ABSTRACT: string
 * }} - Report type.
 */
export const REPORT_TYPE = {
    ED_MOST_VIEWED: `${CAT_ED_REP_BASE}LATEST`,
    ED_OUTSTANDING: `${CAT_ED_REP_BASE}EPRIORITY`,
    ED_LAST_HOUR: `${CAT_ED_REP_BASE}LATEST_HOUR`,
    ED_LAST_VIDEOS: `${CAT_ED_REP_BASE}VIDEOS`,
    ED_FAMOUS: `${CAT_ED_REP_BASE}CORAZON`,
    ED_PERFORMANCE: `${CAT_ED_REP_BASE}ESPECTACULOS`,
    ED_ROYAL: `${CAT_ED_REP_BASE}REALEZA`,
    ED_SPORTS: `${CAT_ED_REP_BASE}DEPORTES`,
    ED_FASHION: `${CAT_ED_REP_BASE}EMODA`,
    ED_POLITICS: `${CAT_ED_REP_BASE}POLITICA`,
    ED_SOCIETY: `${CAT_ED_REP_BASE}SOCIEDAD`,
    ED_ARCHIVE: `${CAT_ED_REP_BASE}ARCHIVO`,
    ED_PREMIUM: `${CAT_ED_REP_BASE}EXCLUSIVOPREMIUM`,
    ED_CLOSED: `${CAT_ED_REP_BASE}CERRADOS`,
    // ED_VPRIORITY: `${CAT_ED_REP_BASE}VPRIORITY`,
    ED_VEDITADOS: `${CAT_ED_REP_BASE}VEDITADOS`,
    CR_MOST_VIEWED: `${CAT_CR_REP_BASE}LATEST`,
    CR_OUTSTANDING: `${CAT_CR_REP_BASE}CPRIORITY`,
    CR_LAST_HOUR: `${CAT_CR_REP_BASE}LATEST_HOUR`,
    CR_LAST_VIDEOS: `${CAT_CR_REP_BASE}VIDEOS`,
    CR_NOURISHMENT: `${CAT_CR_REP_BASE}ALIMENTACION`,
    CR_BEAUTY: `${CAT_CR_REP_BASE}BELLEZA`,
    CR_DECORATION: `${CAT_CR_REP_BASE}DECORACION`,
    CR_NATURE: `${CAT_CR_REP_BASE}NATURALEZA`,
    CR_TRAVEL: `${CAT_CR_REP_BASE}VIAJES`,
    // CR_FASHION: `${CAT_CR_REP_BASE}CMODA`,
    // CR_ABSTRACT: `${CAT_CR_REP_BASE}ABSTRACTO`,
};

/**
 * @name DYNAMIC_WIDGETS_REPORTS
 * @type {Array<string>} - Array of dynamic widgets reports to create the slides-container-component dynamically.
 */
export const DYNAMIC_WIDGETS_REPORTS = [
    REPORT_TYPE.ED_OUTSTANDING,
    REPORT_TYPE.ED_MOST_VIEWED,
    REPORT_TYPE.CR_OUTSTANDING,
    REPORT_TYPE.ED_LAST_HOUR,
    REPORT_TYPE.ED_LAST_VIDEOS,
    REPORT_TYPE.ED_VEDITADOS,
];

/**
 * @name AVOID_CREATIVE_REPORTS
 * @type {Array<string>} - Array of creative reports to avoid.
 */
export const AVOID_CREATIVE_REPORTS = [
    REPORT_TYPE.CR_MOST_VIEWED,
    REPORT_TYPE.CR_LAST_HOUR,
    REPORT_TYPE.CR_LAST_VIDEOS,
];

/**
 * @name AVOID_EDITORIAL_VIDEOS_REPORTS
 * @type {Array<string>} - Array of editorial video reports to avoid.
 */
export const AVOID_EDITORIAL_VIDEOS_REPORTS = [
    REPORT_TYPE.ED_LAST_VIDEOS,
    // REPORT_TYPE.ED_VPRIORITY,
];

/**
 * @name COMMON_REPORTS
 * @type {Array<string>} - Array of common reports.
 */
export const COMMON_REPORTS = [
    REPORT_TYPE.ED_MOST_VIEWED,
    REPORT_TYPE.ED_OUTSTANDING,
    REPORT_TYPE.ED_LAST_HOUR,
    // REPORT_TYPE.ED_LAST_VIDEOS,
    REPORT_TYPE.CR_MOST_VIEWED,
    REPORT_TYPE.CR_OUTSTANDING,
    REPORT_TYPE.CR_LAST_HOUR,
    // REPORT_TYPE.CR_LAST_VIDEOS,
];

/**
 * @name VIDEO_REPORTS
 * @type {Array<string>} - Array of video reports.
 */
export const VIDEO_REPORTS = [REPORT_TYPE.ED_LAST_VIDEOS, REPORT_TYPE.CR_LAST_VIDEOS];

/**
 * @name MAPPING_ROUTES_REPORTS
 * @type {{
 *  ED_REPORTAJES_DESTACADOS: string,
 *  ED_ULTIMA_HORA: string,
 *  ED_MAS_VISTO: string,
 *  ED_VIDEOS_MAS_RECIENTES: string,
 *  CORAZON: string,
 *  ESPECTACULOS: string,
 *  ED_MODA: string,
 *  REALEZA: string,
 *  DEPORTES: string,
 *  POLITICAS: string,
 *  SOCIEDAD: string,
 *  VIDEOS_DESTACADOS: string,
 *  VIDEOS_EDITADOS: string,
 *  ARCHIVO: string,
 *  EXCLUSIVAS_PREMIUM: string,
 *  CR_ULTIMA_HORA: string,
 *  CR_REPORTAJES_DESTACADOS: string,
 *  CR_MAS_VISTO: string,
 *  CR_VIDEOS_MAS_RECIENTES: string,
 *  ALIMENTACION: string,
 *  LIFESTYLE: string,
 *  DECORACION: string,
 *  NATURALEZA: string,
 *  VIAJES: string,
 *  ABSTRACTO: string,
 *  CR_MODA: string
 * }} - Mapping routes for reports.
 */
export const MAPPING_ROUTES_REPORTS = {
    ED_REPORTAJES_DESTACADOS: REPORT_TYPE.ED_OUTSTANDING,
    ED_ULTIMA_HORA: REPORT_TYPE.ED_LAST_HOUR,
    ED_MAS_VISTO: REPORT_TYPE.ED_MOST_VIEWED,
    ED_VIDEOS_MAS_RECIENTES: REPORT_TYPE.ED_LAST_VIDEOS,
    CORAZON: REPORT_TYPE.ED_FAMOUS,
    ESPECTACULOS: REPORT_TYPE.ED_PERFORMANCE,
    ED_MODA: REPORT_TYPE.ED_FASHION,
    REALEZA: REPORT_TYPE.ED_ROYAL,
    DEPORTES: REPORT_TYPE.ED_SPORTS,
    POLITICAS: REPORT_TYPE.ED_POLITICS,
    SOCIEDAD: REPORT_TYPE.ED_SOCIETY,
    VIDEOS_DESTACADOS: REPORT_TYPE.ED_VPRIORITY,
    VIDEOS_EDITADOS: REPORT_TYPE.ED_VEDITADOS,
    ARCHIVO: REPORT_TYPE.ED_ARCHIVE,
    EXCLUSIVAS_PREMIUM: REPORT_TYPE.ED_PREMIUM,
    CR_ULTIMA_HORA: REPORT_TYPE.CR_LAST_HOUR,
    CR_REPORTAJES_DESTACADOS: REPORT_TYPE.CR_OUTSTANDING,
    CR_MAS_VISTO: REPORT_TYPE.CR_MOST_VIEWED,
    CR_VIDEOS_MAS_RECIENTES: REPORT_TYPE.CR_LAST_VIDEOS,
    ALIMENTACION: REPORT_TYPE.CR_NOURISHMENT,
    LIFESTYLE: REPORT_TYPE.CR_BEAUTY,
    DECORACION: REPORT_TYPE.CR_DECORATION,
    NATURALEZA: REPORT_TYPE.CR_NATURE,
    VIAJES: REPORT_TYPE.CR_TRAVEL,
    ABSTRACTO: REPORT_TYPE.CR_ABSTRACT,
    CR_MODA: REPORT_TYPE.CR_FASHION,
};
